import * as s from "pages/recorders/RecordersStyled";
import { ReactComponent as UpdatedIcon } from "assets/icons/update_left.svg";
import {
  FIRMWARE_UPGRADE_STATUS,
  FirmwareUpdateInfoResult,
  FIRMWARE_UPDATE_STEP,
} from "api/interfaces/settingsInterface.interface";
import { updateMessage } from "utils/firmwareUtil";
import { useEffect, useState } from "react";
import StepBar from "components/atoms/step/StepBar";
import BigButton from "components/atoms/buttons/BigButton";

export default function FirmwareUpdate({
  data,
  percent,
  onClickCancel,
  uploadStep,
}: {
  data: FirmwareUpdateInfoResult;
  percent: number;
  onClickCancel: () => void;
  uploadStep: FIRMWARE_UPGRADE_STATUS;
}) {
  const [dot, setDot] = useState(".");

  useEffect(() => {
    const interval = setInterval(() => {
      setDot((prev) => (prev.length < 3 ? prev + "." : "."));
    }, 500);
    return () => clearInterval(interval);
  }, [dot]);

  return (
    <s.UpdateFirmwareStyled.Wrapper>
      <s.UpdateFirmwareStyled.UpdateStatus>
        {updateMessage[uploadStep]}
        {uploadStep !== FIRMWARE_UPGRADE_STATUS.COMPLETE && (
          <span className="dots">{dot}</span>
        )}
      </s.UpdateFirmwareStyled.UpdateStatus>
      <StepBar percent={percent} steps={5} />
      <s.UpdateFirmwareStyled.InfoWrapper>
        <s.UpdateFirmwareStyled.Version.Label
          status={FIRMWARE_UPDATE_STEP.INTRO}
        >
          <span>Current Version</span>
          <b>Version {data.currentVersion}</b>
        </s.UpdateFirmwareStyled.Version.Label>
        <UpdatedIcon />
        <s.UpdateFirmwareStyled.Version.Label
          status={FIRMWARE_UPDATE_STEP.SUCCESS}
        >
          <span>Updated to</span>
          <b>Version {data.updateVersion ?? data.currentVersion}</b>
        </s.UpdateFirmwareStyled.Version.Label>
      </s.UpdateFirmwareStyled.InfoWrapper>
      <s.UpdateFirmwareStyled.UpdateDescription>
        The upgrade process may take up to 10 minutes.
        <br />
        You may close this popup, and the process will continue in the
        background.
        <br /> A notification will inform you of the result.
      </s.UpdateFirmwareStyled.UpdateDescription>
      <s.UpdateFirmwareStyled.Buttons>
        <BigButton
          onClickBtn={onClickCancel}
          label="Close"
          buttonType="cancel"
        />
      </s.UpdateFirmwareStyled.Buttons>
    </s.UpdateFirmwareStyled.Wrapper>
  );
}
